"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AgentEditMarginEditor = exports.MarginType = exports.PercentMargin = exports.MoneyMargin = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const __1 = require("..");
const Field_1 = require("../../../Form/Field");
const MarginTypeSelect_1 = require("../../../Form/Field/MarginTypeSelect");
const utils_1 = require("../utils");
const MoneyMargin = (props) => {
    const { fields } = props;
    if (fields.moneyMargin.hidden)
        return null;
    return (react_1.default.createElement(Field_1.FormField, { label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Agent/Edit:Margin', defaultMessage: 'Margin' }), name: 'moneyMargin', error: fields.moneyMargin.error, value: (0, utils_1.wrapNumericValue)(fields.moneyMargin.value), onChange: (0, utils_1.wrapNumericOnEvent)(fields.moneyMargin.onEvent), modificators: fields.moneyMargin.modifiers, disabled: fields.moneyMargin.disabled }));
};
exports.MoneyMargin = MoneyMargin;
const PercentMargin = (props) => {
    const { fields } = props;
    if (fields.percentMargin.hidden)
        return null;
    return (react_1.default.createElement(Field_1.FormField, { label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Agent/Edit:Margin', defaultMessage: 'Margin' }), name: 'percentMargin', error: fields.percentMargin.error, value: (0, utils_1.wrapNumericValue)(fields.percentMargin.value), onChange: (0, utils_1.wrapNumericOnEvent)(fields.percentMargin.onEvent), modificators: fields.percentMargin.modifiers, disabled: fields.percentMargin.disabled }));
};
exports.PercentMargin = PercentMargin;
const MarginType = (props) => {
    const { fields } = props;
    if (fields.marginType.hidden)
        return null;
    return (react_1.default.createElement(MarginTypeSelect_1.MarginTypeSelect, { label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Agent/Edit:MarginType', defaultMessage: 'Type' }), name: 'marginType', error: fields.marginType.error, value: fields.marginType.value, onChange: fields.marginType.onEvent, modificators: fields.marginType.modifiers, disabled: fields.marginType.disabled }));
};
exports.MarginType = MarginType;
const AgentEditMarginEditor = (props) => {
    const { fields } = props;
    return (react_1.default.createElement("div", { className: `${__1.className}__field` },
        react_1.default.createElement("div", { className: 'form-fields-together' },
            fields.marginType.value === 'money' && (react_1.default.createElement(exports.MoneyMargin, { fields: fields })),
            fields.marginType.value !== 'money' && (react_1.default.createElement(exports.PercentMargin, { fields: fields })),
            react_1.default.createElement(exports.MarginType, { fields: fields }))));
};
exports.AgentEditMarginEditor = AgentEditMarginEditor;
//# sourceMappingURL=margin.js.map